import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { getDryingMechanismTypes } from "../../constants/sizing-constant";
import { getproductsBySizingParameters } from "../../constants/products-constant";

import DryerRefrigerationSizing from "../sizing/DryerRefrigerationSizing";
import DryerAbsorptionSizing from "../sizing/DryerAbsorptionSizing";

export default class DryerAirSizing extends Component {

    state = {
        dryingMechanismTypes: [],
        selecteddryingMechanismType: "0",

        suggestedModel: "",
        suggestedModelId: "",
        sentrifuge: []
    };

    componentDidMount() {
        this.setState({ dryingMechanismTypes: [...getDryingMechanismTypes()] });
    }

    handledryingMechanismSelect = dryingMechanismType => {
        if (dryingMechanismType) {
            this.setState({ selecteddryingMechanismType: dryingMechanismType.value }, () => { });
            if (dryingMechanismType.value === "1") {
                const suggestedProducts = [...getproductsBySizingParameters("درایر", "تبریدی", "")]
                this.props.handler(suggestedProducts)
                return;
            }
            if (dryingMechanismType.value === "2") {
                const suggestedProducts = [...getproductsBySizingParameters("درایر", "گاز", "")]
                this.props.handler(suggestedProducts)
                return;
            }
        }
    };

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.dryingMechanismTypes}
                    placeholder="مکانیزم درایر"
                    onItemSelect={this.handledryingMechanismSelect}
                    value={this.state.selecteddryingMechanismType}
                />
                {this.state.selecteddryingMechanismType === "1" &&
                    <DryerRefrigerationSizing />
                }
                {this.state.selecteddryingMechanismType === "2" &&
                    <DryerAbsorptionSizing />
                }
            </Fragment>
        );
    }
}
